import api from '../config/api';

const configuracionRentaQuintaService = {
  /**
   * Obtener la configuración de renta de quinta para una empresa
   * @param {number} empresaId - ID de la empresa
   * @returns {Promise} - Promesa con la respuesta de la API
   */
  async obtenerConfiguracion(empresaId) {
    try {
      console.log(`💰 Obteniendo configuración de renta de quinta para empresa: ${empresaId}`);
      
      const response = await api.get(`/configuracion-renta-quinta/empresa/${empresaId}`);
      
      console.log('✅ Configuración de renta de quinta obtenida:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ Error al obtener configuración de renta de quinta:', error);
      
      if (error.response?.status === 404) {
        return {
          success: false,
          error: 'Empresa no encontrada'
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de renta de quinta'
      };
    }
  },

  /**
   * Actualizar la configuración de renta de quinta para una empresa
   * @param {number} empresaId - ID de la empresa
   * @param {boolean} activo - Estado de activación de la renta de quinta
   * @returns {Promise} - Promesa con la respuesta de la API
   */
  async actualizarConfiguracion(empresaId, activo) {
    try {
      console.log(`💰 Actualizando configuración de renta de quinta para empresa: ${empresaId}`, {
        empresaId,
        activo
      });
      
      const response = await api.put(`/configuracion-renta-quinta/empresa/${empresaId}`, {
        activo
      });
      
      console.log('✅ Configuración de renta de quinta actualizada:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ Error al actualizar configuración de renta de quinta:', error);
      
      if (error.response?.status === 404) {
        return {
          success: false,
          error: 'Empresa no encontrada'
        };
      }
      
      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de renta de quinta'
      };
    }
  },

  /**
   * Verificar si la renta de quinta está activa para una empresa
   * @param {number} empresaId - ID de la empresa
   * @returns {Promise} - Promesa con la respuesta de la API
   */
  async verificarEstado(empresaId) {
    try {
      console.log(`💰 Verificando estado de renta de quinta para empresa: ${empresaId}`);
      
      const response = await api.get(`/configuracion-renta-quinta/empresa/${empresaId}/estado`);
      
      console.log('✅ Estado de renta de quinta verificado:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ Error al verificar estado de renta de quinta:', error);
      
      if (error.response?.status === 404) {
        return {
          success: false,
          error: 'Empresa no encontrada'
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado de renta de quinta'
      };
    }
  }
};

export default configuracionRentaQuintaService;
